import {
  CAPACITY_PER_PRODUCTION_BUILDING,
  type TileKind,
  type UnitKind,
} from "@dailywars/core/engine";

export const CODEX_TILE_KINDS: TileKind[] = [
  "sea",
  "road",
  "plain",
  "forest",
  "mountain",
  "city",
  "barracks",
  "factory",
  "base",
  "airport",
  "monument",
];

export const TILE_DESCRIPTION: Record<TileKind, string> = {
  plain: "Offers easy movement and more cover than roads.",
  forest: "Slows down vehicles but offers moderate cover.",
  mountain: "Impassable for vehicles. Restricts movements for foot units. Offers great cover.",
  sea: "Impassable for land units.",
  road: "Offers easy movement but less cover than plains.",
  city: "Capturable. Generates 100 funds each turn. Can repair all ground units.",
  barracks: `Capturable. Generates 100 funds each turn. Builds and repairs foot units, and grants ${CAPACITY_PER_PRODUCTION_BUILDING} foot unit capacity.`,
  factory: `Capturable. Generates 100 funds each turn. Builds and repairs vehicles, and grants ${CAPACITY_PER_PRODUCTION_BUILDING} vehicle capacity.`,
  base: `Capturable. Generates 100 funds each turn. Acts as a combined barracks and factory.`,
  airport: `Capturable. Generates 100 funds each turn. Builds and repairs air units, and grants ${CAPACITY_PER_PRODUCTION_BUILDING} air unit capacity.`,
  monument:
    "Capturable. Each owned monument increases your units' firepower by 10%. Some maps require you to capture all monuments to win.",
};

export const BUILDING_TILE_LABEL: Record<
  "city" | "barracks" | "factory" | "base" | "airport" | "monument",
  string
> = {
  city: "City",
  barracks: "Barracks",
  factory: "Factory",
  base: "Base",
  airport: "Airport",
  monument: "Monument",
};

export const UNIT_DESCRIPTION: Record<UnitKind, string> = {
  rifleman: "General-purpose infantry. Can capture buildings.",
  rpgInfantry: "Slow anti-armor specialist. Can capture buildings.",
  sniper:
    "Long-range anti-infantry specialist. Can capture buildings. Differs from other indirect fire units in that it can move and shoot in the same turn.",
  artillery: "Cheap artillery vehicle. Cannot move and shoot in the same turn.",
  rockets: "Long-range rocket launcher. Cannot move and shoot in the same turn.",
  lightTank: "Fast armored tank.",
  heavyTank: "Slow but powerful tank.",
  antiAir: "Fast autocannon vehicle strong against infantry and air.",
  missiles: "Long-range missile launcher for anti-air. Cannot move and shoot in the same turn.",
  landTransport:
    "Fast vehicle that can carry infantry. Gains the attack of the carried foot soldier when loaded.",
  battleCopter: "Versatile air unit effective against ground units and other copters.",
  fighterJet: "Fast air unit specialized against other air units.",
  bomber: "Heavy ground-attack air unit.",
  transportCopter: "Carries infantry over any terrain.",
};
